import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Keyword Planner route (`/explorer/keyword-planner`).
 * Super-admin only — Google Ads keyword demand/competition/bid data across a
 * subsidiary's connections. Lazy-loaded to keep it off the initial
 * authenticated bundle.
 */
const KeywordPlannerPage = lazy(() => import('~/features/explorer/pages/keyword-planner-page'));

// Persist the page-local subsidiary scope in the URL (opaque `?sc=`) so a reload
// / shared link keeps the picked subsidiary instead of snapping to the active tenant.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/explorer/keyword-planner')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <KeywordPlannerPage />
    </Suspense>
  );
}
